import { SxProps } from "@mui/material";

export const sxTypographyTitle: SxProps = {
    fontFamily: 'UnimedSans-Bold',
    color: '#383838',
    textAlign: 'center',
    fontSize: '28px'
};

export const sxTypographySubTitle: SxProps = {
    fontFamily: 'Unimed-Sans',
    color: '#4C4C4C',
    textAlign: 'center',
    maxHeight: '400px',
    overflow: 'auto',
    minHeight: '32px'
};

export const sxButton: SxProps = {
    borderRadius: 80,
    padding: '12px 32px',
    minHeight: '44px',
    border: 2,
    '@media(max-width: 899px)': {
        width: '100%'
    },
    '&:focus': {
        color: 'rgb(0,0,0,0.08)',
        background: '#fff'
    }
};

export const sxButtonContained: SxProps = {
    borderRadius: 80,
    padding: '12px 32px',
    minHeight: '44px',
    '@media(max-width: 899px)': {
        width: '100%'
    }
};


export const sxTextButton: SxProps = {
    fontFamily: 'UnimedSans-Bold',
    fontSize: 16,
    color: '#00995D',
};

export const sxTextButtonContained: SxProps = {
    fontFamily: 'UnimedSans-Bold',
    fontSize: 16,
    color: '#fff',
};

export const sxCloseIconButton: SxProps = {
    position: 'absolute',
    right: '16px',
    top: '16px',
    color: '#383838',
    '@media(max-width: 650px)': {
        right: '16px',
        top: '12px'
    }
}

export const sxModal: SxProps = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '30%',
    minWidth: '250px',
    bgcolor: '#fff',
    borderRadius: '16px',
    border: 'none',
    boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
    padding: '32px 48px',
    gap: '20px',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '100vh',
    overflow: 'auto',
    '@media(max-width: 768px)': {
        maxWidth: '70%',
        maxHeight: '95vh'
    },
    '@media(max-height: 500px) and (orientation: landscape)': {
        minWidth: '600px',
        maxWidth: '90%',
        maxHeight: '95vh',
        padding: '32px 15px',
        gap: '12px'
    }
}